module.exports = __webpack_public_path__ + "img/pavl5.bcd3a6f4.jpg";